<template>
  <button
    type="button"
    class="market-switcher__trigger icon-button"
    :aria-label="$string('general.market_switcher.trigger')"
    @click="openOverlay({
      component: 'market-switcher',
      ignoreDismissed: true,
      namespace: 'marketSwitcher',
      clearQueue: false,
    })"
    @click.stop
    v-text="triggerText"
  />
</template>

<script>

/**
 * Vue: Multi-store trigger (market-switcher-trigger)
 * -----------------------------------------------------------------------------
 * Button to trigger market-switcher modal.
 *
 */
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MarketSwitcherTrigger',

  props: {
    placement: {
      type: String,
      default: 'footer',
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      country: (state) => state['market-switcher'].country,
      language: (state) => state['market-switcher'].language,
    }),

    /**
     * Compute trigger text.
     * @returns {String}
     */
    triggerText() {
      if (this.placement === 'header') {
        return `${this.country.code} / ${window.cnvs.store.currency}`
      }

      if (this.placement === 'footer') {
        return `${this.country.name} / ${this.language.name}`
      }

      return `${this.country.code} / ${this.language.code}`
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
      closeOverlay: 'overlays/close',
    }),
  },
}
</script>
